import Moment from 'moment';
import { extendMoment } from 'moment-range';
let moment = extendMoment(Moment);

// Busca las horas que esa persona trabaja el dia indicado
// necesario saber las hora que trabaja ese dia
export const findDay = person => {
	const day = moment().isoWeekday() - 1;
	return getDiff(person.start[day], person.end[day], person.discount[day]);
};

// obtiene la cantidad de horas que ese person debe trabajar ese dia
// duration retorna number el equivalente en horas ej: 9.5 que equivalente a 9:30
// utc retonara en horas ej: 9:30
const getDiff = (start, end, discount) => {
	let endDate = moment(end, 'HH:mm:ss').subtract({ minutes: discount });
	return moment.duration(`${endDate.diff(moment(start, 'HH:mm:ss'))}`);
};

// Establece total ganado
// calcula el total ganado segun las horas que le tocaba trabajar ese dia
export const setEarned = person => {
	let hours = findDay(person).asHours();
	// retornamos el total del dia ganado
	return hours.toFixed(2) * person.salary;
};

// Establece el total ganado
// Calcula segun las horas que trabajo ese dia el total ganado
export const setEarnedToday = (start, end, person) => {
	const today = moment().day();
	const endDate = moment(end).subtract(person.discount[today - 1], 'minutes');
	const duration = moment.duration(`${endDate.diff(moment(start))}`);
	const totalHours = duration.asHours();
	// retornamos el total del dia ganado
	return totalHours.toFixed(2) * person.salary;
};
